import styled, { css } from "styled-components";

const Row = styled.div`
  display: flex;

  ${(props) =>
    props.type === "horizontal" &&
    css`
      justify-content: space-between;
      align-items: center;
    `}

  ${(props) =>
    props.type === "vertical" &&
    css`
      width:80%;
      flex-direction: column;
      gap: 1.6rem;
      float:right
    `}
`;

Row.defaultProps = {
  type: "vertical",
};

export default Row;
